exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stickybar[data-v-9a04c72a]{padding:10px 10px 10px 10px}.stickybartext[data-v-9a04c72a]{font-size:16px;font-weight:700}.flex-container[data-v-9a04c72a]{border:1px solid #c7c7c7}.subtarget-mainheader[data-v-9a04c72a]{padding:10px 10px 10px 14px;background-color:#ccc;color:#000;font-weight:700}@media print{.prof_Spe026PrDetailPE .stickybar[data-v-9a04c72a]{display:none}}", ""]);

// exports
